import { useRequiredContext } from "@redotech/react-util/context";
import { ConversionFeature } from "@redotech/redo-conversion-settings-common/checkout-optimization-settings";
import { useTranslation } from "@redotech/redo-i18n";
import ScalesIcon from "@redotech/redo-icons/scales-01.svg";
import ScalesFilledIcon from "@redotech/redo-icons/scales-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { memo } from "react";
import { LockableSecondaryNavItem } from "./lockable-secondary-nav-item";

export const AbTestItems = memo(function AbTestItems() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <LockableSecondaryNavItem
      buttonLocation={ScheduleDemoButtonLocation.NAV_AB_TESTS}
      feature={ConversionFeature.AB_TESTS}
      FilledIcon={ScalesFilledIcon}
      friendlyName={t("A/B tests", {
        context: "checkout conversion navigation label",
      })}
      href={routes.getConversionSubRoute("ab-tests")}
      id="ab-tests"
      UnfilledIcon={ScalesIcon}
    />
  );
});
